module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"open":"Open","closed":"Closed","user_grade":"User Grade","author_grade":"Author Grade"}}')
  delete Component.options._Ctor
}
